"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GreenCardRequest = void 0;
class GreenCardRequest {
}
exports.GreenCardRequest = GreenCardRequest;
//# sourceMappingURL=GreenCardRequest.js.map